import styled from 'styled-components';
import AnimatedLoader from './centred';

export default styled(AnimatedLoader)`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
`;



// WEBPACK FOOTER //
// ./app/components/AnimatedLoader/fullScreen.js